/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-component-video-asset-list-component.ts
 *
 * Created by randysorensen on 9/23/18.
 */

function PackageMediaComponentVideoAssetListController (
    this: JS5Object,
    _: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.getComponentVideoList = () => {
        return PackageMediaService.getAssetList('Video', this.componentRole);
    };

    this.getIngestPercent = () => {
        return PackageMediaService.calculateIngestPercent(this.getComponentVideoList());
    };

    this.getValidationStatus = () => {
        if (this.componentRole.isDefault || !!_.size(this.componentRole._partnersRequiring)) {
            return 'REQUIRED';
        } else {
            return 'OPTIONAL';
        }
    };

    this.addNewComponentVideo = () => {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: PackageMediaService.getPrimaryAcceptTemplateMember(),
            type: 'Video',
            role: this.componentRole
        });
        PackageUtilService.editorForm.$setDirty();
    };

    this.removeComponentVideo = (componentVideoAsset: JS5Object) => {
        _.pull(PackageMediaService.packageMediaData.assets, componentVideoAsset);
        PackageUtilService.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {

    };
}

angular.module('prism-ui.package').component('packageMediaComponentVideoAssetList', {
    controller: PackageMediaComponentVideoAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/videoComponentAssetList/package-media-component-video-asset-list-template.html',
    bindings: {
        componentRole: '<'
    }
});
